import {useEffect} from 'react';
import {useHref, useLocation, useNavigate} from 'react-router';

import {docsBasePath as basePath} from '../../site-config.mjs';

function isChinesePath(pathname: string): boolean {
  const path = pathname === basePath
    ? '/'
    : pathname.startsWith(`${basePath}/`) ? pathname.slice(basePath.length) : pathname;
  return path === '/zh-CN' || path.startsWith('/zh-CN/');
}

export default function HeaderLogoLocaleLink(): null {
  const location = useLocation();
  const navigate = useNavigate();
  const target = isChinesePath(location.pathname) ? '/zh-CN/home' : '/home';
  const homeHref = useHref(target);

  useEffect(() => {
    const logoLink = Array.from(document.querySelectorAll<HTMLAnchorElement>('header a'))
      .find((link) => link.querySelector('img[alt="WEEX"]'));

    if (!logoLink) return;

    const handleClick = (event: MouseEvent) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      void navigate(target);
    };

    logoLink.href = homeHref;
    logoLink.addEventListener('click', handleClick, {capture: true});

    return () => {
      logoLink.removeEventListener('click', handleClick, {capture: true});
    };
  }, [homeHref, target, navigate]);

  return null;
}
